module.exports = __webpack_public_path__ + "img/Dourbie-langudedoc-arbre.b10c3f77.jpg";